// extracted by mini-css-extract-plugin
export default {"bgImg":"carousel_bgImg__neHOq","shadow":"carousel_shadow__rz5KT","text":"carousel_text__zAjHI","Ptext":"carousel_Ptext__W6f2W"};